export function toggleDarkMode() {
    return { type: 'TOGGLE_DARK_MODE' };
}
